import { csrfFetch } from './csrf-fetch.js';

/**
 * Remembers the current URL on the server so the settings page can send the visitor back here,
 * then navigates there.
 */
export async function openCookieSettings(redirectUrl) {
  if (!redirectUrl) {
    return;
  }

  try {
    await csrfFetch('/shopController.php?objective=saveOrigin', {
      method: 'POST',
      body: new URLSearchParams({ location: window.location.href }),
    });
  } catch {
    // Navigating without a return target beats trapping the visitor here.
  }

  window.location.href = redirectUrl;
}
